export interface ReportingAgentScope {
  actorId: string | undefined
  organizationId: string | undefined
}

const root = (
  actorId: string | undefined,
  organizationId: string | undefined,
) => ['reportingAgent', actorId, organizationId] as const

export const reportingAgentQueryKeys = {
  root,
  draftRequest: (
    actorId: string | undefined,
    organizationId: string | undefined,
    draftRequestId: string | undefined,
  ) =>
    [...root(actorId, organizationId), 'draftRequest', draftRequestId] as const,
  messages: (
    actorId: string | undefined,
    organizationId: string | undefined,
    conversationId: string | undefined,
  ) => [...root(actorId, organizationId), 'messages', conversationId] as const,
  run: (
    actorId: string | undefined,
    organizationId: string | undefined,
    runId: string | undefined,
  ) => [...root(actorId, organizationId), 'run', runId] as const,
  draftDisplay: (
    actorId: string | undefined,
    organizationId: string | undefined,
    conversationId: string | undefined,
    artifactId: string | undefined,
  ) =>
    [
      ...root(actorId, organizationId),
      'draftDisplay',
      conversationId,
      artifactId,
    ] as const,
}
